import { EventEmitter, Component } from '@angular/core';

class Modals {

  readonly events: EventEmitter<any> = new EventEmitter();

  readonly registry: { [s: string]: Component }|any = {};

  register(...modalMaps: { [s: string]: any }[]) {
    modalMaps.forEach(modal => {
      Object.assign(this.registry, modal)
    })
  }

  launch(component: any, data: any) {
    // this.events.emit({ event: 'launch modal', data: { data, modal } })
    this.events.emit({ event: 'show modal', data: { component, data } });
  }

}

export const modals = new Modals();
